export const strip = (s) =>
  String(s || '')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

const ROLE_CANON = {
  finalizzatore:'Finalizzatore', finisher:'Finalizzatore',
  'editor video':'Editor Video', montatore:'Editor Video',
  'assistente al montaggio':'Assistente al montaggio',
  colorist:'Colorist', 'post producer':'Post Producer',
  'delegato di produzione':'Delegato di Produzione', conforming:'Conforming'
};
const SKILL_CANON = {
  premiere:'Adobe Premiere Pro','adobe premiere':'Adobe Premiere Pro','adobe premiere pro':'Adobe Premiere Pro',
  'final cut':'Final Cut', finalcut:'Final Cut', fcpx:'Final Cut',
  avid:'Avid Media Composer','avid media composer':'Avid Media Composer',
  resolve:'DaVinci Resolve', davinci:'DaVinci Resolve','davinci resolve':'DaVinci Resolve',
  color:'Color grading','color grading':'Color grading','color correction':'Color grading',
  ae:'After Effects','after effects':'After Effects',
  'motion graphics':'Motion graphics', mograph:'Motion graphics',
  conforming:'Conforming','audio cleanup':'Audio cleanup',
  'broadcast deliverables':'Broadcast deliverables', storytelling:'Storytelling'
};

export const canonicalizeRole  = (v) => ROLE_CANON[strip(v)]  || (v || '').trim();
export const canonicalizeSkill = (v) => SKILL_CANON[strip(v)] || (v || '').trim();

export const uniq = (arr) => {
  const seen = new Set();
  const out = [];
  for (const v of arr || []) {
    const k = strip(v);
    if (!seen.has(k)) { seen.add(k); out.push((v || '').trim()); }
  }
  return out;
};

export const normalizeRoles  = (arr) => uniq((arr || []).map(canonicalizeRole));
export const normalizeSkills = (arr) => uniq((arr || []).map(canonicalizeSkill));
